import Logo from '../Common/Logo'

export default function Footer() {
  return (
    <footer className="bg-primary-900 text-white py-10">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col items-center gap-4">
          <Logo size={40} />
          <p className="text-primary-300 font-semibold">PetHalo</p>
          <p className="text-primary-400 text-sm">
            Safe Pets. Smarter Tags.
          </p>
          <div className="w-16 h-px bg-primary-700 my-2" />
          <p className="text-primary-500 text-sm">
            &copy; {new Date().getFullYear()} PetHalo. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  )
}
